const root = state => state.formCreation || {};
export const getFormCreationRequestState = state => root(state).requestState;
export const getSelectedType = state => root(state).selectedType;
export const getSelectedBusinessUnitId = state => root(state).selectedBusinessUnit;